<template>
    <Overlay :show="showLoading">
        <b-card>
            <b-row class="pb-2">
                <b-col class="d-flex align-items-center justify-content-between">
                    <h2 class="float-left pr-1">
                        {{ $t('Page(SCIPPreview):Component(Label):page-label') }}
                    </h2>
                    <div>
                        <Overlay :show="buttonsLoading">
                            <Button
                                :disabled="isSubmissionButtonDisabled"
                                @click="makeSubmission"
                            >
                                {{ $t('Component(Button):make-scip-notification') }}
                            </Button>

                            <Button
                                class="ml-1"
                                @click="back"
                            >
                                {{ $t('Component(Button):back') }}
                            </Button>
                        </Overlay>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <ArticleTree
                        :article="actualArticle"
                        @change="onArticleChange"
                    />
                </b-col>
            </b-row>
        </b-card>
    </Overlay>
</template>
<script>
import Overlay from "@core/components/common/Overlay.vue";
import {ProductProvider} from "@core/domain/product";
import { BCard, BRow, BCol } from 'bootstrap-vue'
import ArticleTree from "@/views/product/components/scip-notification/ArticleTree.vue";
import Button from "@core/components/common/Button.vue";
import backendResponse from "@core/mixins/ui/backend-response";
export default {
    mixins: [backendResponse],
    components: {
        Button,
        Overlay, BCard, BRow, BCol, ArticleTree
    },
    props: {
        id: {
            required: true
        }
    },
    data() {
        return {
            showLoading: true,
            buttonsLoading: false,
            card: {
                names: []
            },
            isSubmissionButtonDisabled: true,
            previousArticle: null,
            gatherFactsTimeout: null,
            actualArticle: {
                availableNames: [],
                availableIdentifiers: [],
                categories: [],
                safeUseInstructions: null,
                scipSettings: {
                    productionFlag: null,
                    otherIdentifiers: [],
                    otherNames: []
                },
                isExcluded: false,
                scipName: '',
                primaryIdentifier: {
                    value: ''
                },
                primaryName: {
                    value: ''
                },
                children: [],
                concernElements: [],
            }
        };
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        makeSubmission() {
            this.showLoading = true;
            ProductProvider(this.id)
                .makeScipSubmission()
                .then((r) => {
                    this.showDefaultSuccessMessage(
                        this.$t('Page(SCIPPreview):Component(SCIPNotificationScheduledAck):message'),
                        true,
                        this.$t('Page(SCIPPreview):Component(SCIPNotificationScheduledAck):title'),
                    );
                    this.gotoScipNotificationOverview();
                })
                .catch(this.handleBackendError)
                .finally(() => this.showLoading = false)
            ;
        },
        gotoScipNotificationOverview() {
            this.$router.push({
                name: 'submission-overview'
            })
        },
        onArticleChange() {
            clearTimeout(this.gatherFactsTimeout);
            this.gatherFactsTimeout = setTimeout(() => {
                this.buttonsLoading = true;
                ProductProvider(this.id)
                    .getSCIPNotificationFacts(true)
                    .then(facts => {
                        this.isSubmissionButtonDisabled = !facts.isNotificationGranted;
                    })
                    .finally(() => this.buttonsLoading = false);
            }, 700);
        },
        gatherFactsAndProcess() {
            ProductProvider(this.id)
                .getSCIPNotificationFacts()
                .then(facts => {
                    if (facts.isNotificationGranted) {
                        this.isSubmissionButtonDisabled = false;
                    }
                    // if (false === facts.isNotificationGranted) {
                    //     this.$router.push({
                    //         name: 'product-card',
                    //         params: {id: this.id}
                    //     })
                    // } else {
                        this.init();
                    // }
                })
        },
        init() {
            let product = ProductProvider(this.id);
            product
                .getCard()
                .then(card => {
                    this.card = card;
                });
            product
                .getSCIPPreview()
                .then(preview => {
                    this.previousArticle = preview.previous;
                    this.actualArticle = preview.actual;
                })
                .finally(() => this.showLoading = false)
            ;
        }
    },
    computed: {
        productTitle() {
            if (this.card.names.length === 0) {
                return ''
            }

            return this.card.names[0].value;
        }
    },
    created() {
        this.gatherFactsAndProcess();
    },
}
</script>
